import { ajaxPostJson } from './ajax';

// 源语言与目标语言
export const queryLangList = (params) => {
  return ajaxPostJson(`/common/queryLangList`, params);
};

// 根据源语言和目标语言查询领域
export const queryTransDomain = (params) => {
  // params.dataType = 'trans_domain';
  return ajaxPostJson(`/common/queryTransDomain`, params);
};

// 得到上传签名
export const getUploadSign = (params = {}) => {
  return ajaxPostJson(`/file/getUploadSign`, params);
};

// 检测文件语言
export const getFileLang = (params) => {
  return ajaxPostJson(`/file/language`, params);
};

// 获得记忆库术语库列表
export const querySelectableTermMemoryList = (params) => {
  return ajaxPostJson(`/project/querySelectableTermMemoryList`, params);
};

// 获得翻译引擎列表
export const queryTranslationEngine = (params) => {
  return ajaxPostJson(`/mtSupplierTrans/findAll`, params, 'BaseApi3');
};

// 获取所有质量检测项
export const queryAllQuality = (params) => {
  return ajaxPostJson(`/transQa/findAll`, params);
};

// 获取所有文档设置分组
export const queryDocSet = (params) => {
  return ajaxPostJson(`/projectDocumentSetting/findAll`, params);
};

// 获得所有断句规则
export const queryAllPunctuateRule = (params) => {
  return ajaxPostJson(`/transSegmentRule/queryAll`, params);
};

// 新建项目
export const saveProject = (params) => {
  params.dataType = 'trans_domain';
  return ajaxPostJson(`/project/save`, params);
};

// 轮询记忆库
export const queryMemorySentCount = (params) => {
  return ajaxPostJson(`/memory/querySentCount`, params);
};
// 轮询术语库
export const queryTermSentCount = (params) => {
  return ajaxPostJson(`/term/querySentCount`, params);
};

// 创建项目默认领域
export const queryDefaultTransDomain = (params) => {
  params.dataType = 'trans_domain';
  return ajaxPostJson(`/project/queryDefaultTransDomain`, params);
};